import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { Messages } from '../../codegen/Localize';
import {userCanEditSchedule } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleEdit } from './ScheduleMenuActions';

export const ScheduleEditAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EditSchedule,
  translateName: Messages.editScheduleSettings_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return targetItems.length === 1;
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEdit(targetItems)
};
